const prefix = "[AD]";

export default {
    FETCH_ADD_REQUEST: `${prefix} FETCH_ADD_REQUEST`,
    FETCH_ADD_SUCCESS: `${prefix} FETCH_ADD_SUCCESS`,
    FETCH_ADD_FAILED: `${prefix} FETCH_ADD_FAILED`,
};
